import React, {Fragment, useContext} from "react" ;

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import LetterboxAppQuickMenu from "./LetterboxAppQuickMenu";
import {Route, Switch, useLocation} from "react-router-dom";
import ChildPostsSubmenu from "./ChildPostsSubmenu";
import ChildLetterboxSubmenu from "root/Wieldy/ApplicationModules/Child/Sidebar/ChildLetterboxSubmenu";
import ChildDashboardSubmenu from "root/Wieldy/ApplicationModules/Child/Sidebar/ChildDashboardSubmenu";
import ChildResourcesSubmenu from "root/Wieldy/ApplicationModules/Child/Sidebar/ChildResourcesSubmenu";
import ChildMessagingSubmenu from "root/Wieldy/ApplicationModules/Child/Sidebar/ChildMessagingSubmenu";

import {getChildRouterLink, getChildRouterPath, PATH_CHILD_ROOT} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import {currentChildAtom} from "root/recoil/childId";
import {useRecoilValue} from "recoil";
import {UserRoleGroups} from "root/DataFunctions/Constants";
import GlobalContext from "root/contexts/GlobalContext";
import {getDefaultMenuForPath} from "root/Wieldy/ApplicationModules/Common/navHelpers";
import ChildCommunicationsPlanSubmenu from "root/Wieldy/ApplicationModules/Child/Sidebar/ChildCommunicationsPlanSubmenu";
import phpVars from 'phpVars';
import ChildInfoForm from "root/Wieldy/ApplicationModules/Child/Body/ChildDetails/ChildInfoForm";
import MessagingTab from "root/Wieldy/ApplicationModules/Messaging/Body/MessagingTab";
import PostsTab from "root/Wieldy/ApplicationModules/Posts/Body/PostsTab";

const ChildAppSidebar= (props) =>
{
    const currentChild = useRecoilValue(currentChildAtom);
    const { pathname }  = useLocation();

    const menuRoutes = [
        { match: '/details' , defaultMenu: 'details', default: true},
        { match: '/posts' , defaultMenu: 'posts'},
        { match: '/messaging' , defaultMenu: 'messages'},
        { match: '/letterbox' , defaultMenu: 'letterbox'},
        { match: '/connections' , defaultMenu: 'connections'},
        { match: '/families' , defaultMenu: 'families'},
        { match: '/commsplans' , defaultMenu: 'commsplans'},
        { match: '/resources' , defaultMenu: 'resources'},
        { match: '/stats' , defaultMenu: 'dashboard'},
    ]

    const getDefaultMenu = () =>{
        return getDefaultMenuForPath( pathname, menuRoutes ) ;
    }

    const childSubmenu =() =>{

        const globals = useContext(GlobalContext);
        const isStaff = UserRoleGroups.CAN_BE_STAFF.includes(+(globals.userType));
        const canAssignResources = UserRoleGroups.CAN_ASSIGN_RESOURCES.includes(+(globals.userType));
        const has_lifestory = phpVars.has_lifestory === 1 ? true :false;

        return(
            <Fragment>
                { currentChild !== undefined && <AppSidebarGroup title='View' default={getDefaultMenu()}>
                    { ( currentChild.is_manager || currentChild.is_editor) && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'details')} title='Details' iconName='icon-user-o' name='details' />}
                    { ( currentChild.is_manager || currentChild.is_editor || currentChild.is_messager) && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'messaging')} title='Messages' iconName='icon-chat' name='messages'/> }
                    { ( currentChild.is_manager || currentChild.is_editor || currentChild.is_contributor ) && has_lifestory && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=new')} title='Posts' iconName='icon-camera' name='posts'/> }
                    { currentChild.is_manager && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'connections')} title='Connections' iconName='icon-family' name='connections'/> }
                    {has_lifestory && currentChild.is_manager && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'families')} title='Families' iconName='icon-crm' name='families'/> }
                    { currentChild.is_manager && isStaff && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'commsplans')} title='Communication Plans' iconName='icon-timeline' name='commsplans'/> }
                    {has_lifestory && (currentChild.is_manager || canAssignResources) && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'resources')} title='Resources' iconName='icon-files' name='resources'/> }
                    { currentChild.is_manager && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'stats')} title='Dashboard' iconName='icon-dashboard' name='dashboard'/> }
                </AppSidebarGroup> }
            </Fragment>
        )
    }

    return (
        <div className="dt-module__sidebar">

            <div className="dt-module__sidebar-header border-bottom">
                <div className="d-none d-md-flex align-items-center justify-content-center">
                    <i className={ "icon " + props.iconName + " icon-2x mr-4"}/>
                    <span className="h2 mb-0 text-muted">{props.title}</span>
                </div>

                <LetterboxAppQuickMenu />
            </div>

            { /* Sidebar Menu */}
            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    {childSubmenu()}

                    <Switch>
                        <Route path={getChildRouterPath('posts')} render={(thisprops) => <ChildPostsSubmenu child_uid={props.child_uid} is_editor={currentChild.is_editor} {...thisprops}/>}/>
                        <Route path={getChildRouterPath('stats')} render={(thisprops) => <ChildDashboardSubmenu child_uid={props.child_uid} {...thisprops}/>}/>
                        <Route path={getChildRouterPath('letterbox')} render={(thisprops) => <ChildLetterboxSubmenu child_uid={props.child_uid} {...thisprops}/>}/>
                        <Route path={getChildRouterPath('messaging')} render={(thisprops) => <ChildMessagingSubmenu child_uid={props.child_uid} is_editor={currentChild.is_editor}{...thisprops}/>}/>
                        <Route path={getChildRouterPath('resources')} render={(thisprops) => <ChildResourcesSubmenu child_uid={props.child_uid} {...thisprops}/>}/>
                        <Route path={getChildRouterPath('commsplans')} render={(thisprops) => <ChildCommunicationsPlanSubmenu child_uid={props.child_uid} {...thisprops}/>}/>
                        { ( currentChild.is_messager) &&<Route path={PATH_CHILD_ROOT} render={(thisprops) => <ChildMessagingSubmenu child_uid={props.child_uid} is_editor={currentChild.is_editor}{...thisprops}/>}/>}
                        { ( currentChild.is_contributor) &&<Route path={PATH_CHILD_ROOT} render={(thisprops) => <ChildPostsSubmenu child_uid={props.child_uid} is_editor={currentChild.is_editor} {...thisprops}/>}/>}
                    </Switch>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default ChildAppSidebar;
